import styled from 'styled-components';
import {
  destructiveColor,
  colorWhite,
  secondaryGhostDarkColor,
  intuitPrimaryColor,
  turbotaxPrimaryColor,
  mintTurbotaxIconColor
} from './StyledButton';

const data = {
  intuit: {
    labelColor: {
      primary: colorWhite,
      secondary: secondaryGhostDarkColor,
      secondaryGhost: intuitPrimaryColor,
      tertiary: intuitPrimaryColor
    },
    labelColorDarkTheme: {
      primary: colorWhite,
      secondary: secondaryGhostDarkColor,
      secondaryGhost: colorWhite,
      tertiary: colorWhite
    }
  },
  quickbooks: {
    labelColor: {
      primary: colorWhite,
      secondary: secondaryGhostDarkColor,
      secondaryGhost: secondaryGhostDarkColor,
      tertiary: intuitPrimaryColor
    },
    labelColorDarkTheme: {
      primary: colorWhite,
      secondary: colorWhite,
      secondaryGhost: colorWhite,
      tertiary: colorWhite
    }
  },
  turbotax: {
    labelColor: {
      primary: colorWhite,
      secondary: secondaryGhostDarkColor,
      secondaryGhost: mintTurbotaxIconColor,
      tertiary: turbotaxPrimaryColor
    },
    labelColorDarkTheme: {
      primary: turbotaxPrimaryColor,
      secondary: secondaryGhostDarkColor,
      secondaryGhost: colorWhite,
      tertiary: colorWhite
    }
  },
  mint: {
    labelColor: {
      primary: colorWhite,
      secondary: secondaryGhostDarkColor,
      secondaryGhost: mintTurbotaxIconColor,
      tertiary: turbotaxPrimaryColor
    },
    labelColorDarkTheme: {
      primary: turbotaxPrimaryColor,
      secondary: secondaryGhostDarkColor,
      secondaryGhost: colorWhite,
      tertiary: colorWhite
    }
  }
};

const labelSizes = {
  mini: {
    labelFontSize: '12px',
    labelLineHeight: '16px',
    padding: '4px 20px'
  },
  standard: {
    labelFontSize: '16px',
    labelLineHeight: '20px',
    padding: '8px 20px'
  },
  responsive: {
    labelFontSize: '16px',
    labelLineHeight: '24px',
    padding: '8px 20px'
  },
  jumbo: {
    labelFontSize: '19px',
    labelLineHeight: '24px',
    padding: '12px 20px'
  }
};

const labelIconSizes = {
  mini: {
    labelLineHeight: '16px',
    padding: '4px 20px'
  },
  standard: {
    padding: '6px 20px',
    labelLineHeight: '24px'
  },
  responsive: {
    padding: '6px 20px',
    labelLineHeight: '28px'
  },
  jumbo: {
    padding: '10px 20px',
    labelLineHeight: '28px'
  }
};

const ghostLabelSizes = {
  mini: {
    padding: '2px 18px'
  },
  standard: {
    padding: '6px 18px'
  },
  responsive: {
    padding: '6px 18px'
  },
  jumbo: {
    padding: '10px 18px'
  }
};

const labelIconSizesWithBorder = {
  standard: {
    padding: '4px 18px',
    labelLineHeight: '24px'
  },
  responsive: {
    padding: '4px 18px',
    labelLineHeight: '28px'
  },
  jumbo: {
    padding: '8px 18px',
    labelLineHeight: '28px'
  }
};

const boltLabelSizes = {
  mini: {
    padding: '2px 20px',
    labelLineHeight: '18px'
  },
  standard: {
    padding: '6px 20px',
    labelLineHeight: '20px'
  },
  responsive: {
    padding: '8px 20px',
    labelLineHeight: '20px'
  },
  jumbo: {
    padding: '10px 20px',
    labelLineHeight: '28px'
  }
};

const Label = styled.span`
  font-weight: 600;
  color: ${colorWhite};
  display: inline-block;
  ${props => `
    font-size: ${labelSizes[props.size].labelFontSize};
    line-height: ${labelSizes[props.size].labelLineHeight};
  `}

  padding: ${props =>
    props.icon
      ? labelIconSizes[props.size].padding
      : labelSizes[props.size].padding};
  line-height: ${props =>
    props.icon
      ? labelIconSizes[props.size].labelLineHeight
      : labelSizes[props.size].labelLineHeight};
  ${props =>
    props.buttonType === 'secondaryGhost' &&
    `padding: ${
      props.icon
        ? labelIconSizesWithBorder[props.size].padding
        : ghostLabelSizes[props.size].padding
    }`};
  ${props =>
    props.buttonType === 'secondaryGhost' &&
    `line-height: ${
      props.icon
        ? labelIconSizesWithBorder[props.size].labelLineHeight
        : labelSizes[props.size].labelLineHeight
    }`};

  ${props =>
    props.theme === 'quickbooks' &&
    (props.icon || props.buttonType === 'secondary') &&
    `padding: ${boltLabelSizes[props.size].padding}`};
  ${props =>
    props.theme === 'quickbooks' &&
    (!props.icon && props.buttonType === 'secondary') &&
    `line-height: ${boltLabelSizes[props.size].labelLineHeight}`};
  ${props =>
    props.theme === 'quickbooks' &&
    props.buttonType === 'secondary' &&
    props.icon &&
    `padding: ${labelIconSizesWithBorder[props.size].padding}`};

  ${props =>
    props.buttonType !== 'destructiveTertiary' &&
    `
    color: ${data[props.theme].labelColor[props.buttonType]};
  `}
  ${props =>
    props.buttonType === 'destructiveTertiary' &&
    `
    color: ${destructiveColor};
  `}
  ${props =>
    props.inverse &&
    `
    color: ${data[props.theme].labelColorDarkTheme[props.buttonType]};
  `}
`;

export default Label;
